import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useCallback, useState } from 'react';
import { LocalAlertConfig } from '../../types/localeAlerts.ts';
type OpenChangeHandler = (open: boolean) => void;
type UseModalAlertsResult = {
  alerts: LocalAlertConfig[];
  setAlerts: Dispatch<SetStateAction<LocalAlertConfig[]>>;
  clearAlerts: () => void;
  removeAlert: (id: string) => void;
  handleOpenChange: (open: boolean, onOpenChange?: OpenChangeHandler) => void;
};
const useModalAlerts = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [alerts, setAlerts] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setAlerts([]);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clearAlerts = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = id => {
      setAlerts(prevAlerts => prevAlerts.filter(alert => alert.id !== id));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const removeAlert = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (open, onOpenChange) => {
      if (!open) {
        clearAlerts();
      }
      onOpenChange?.(open);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleOpenChange = t3;
  let t4;
  if ($[4] !== alerts) {
    t4 = {
      alerts,
      setAlerts,
      clearAlerts,
      removeAlert,
      handleOpenChange
    };
    $[4] = alerts;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default useModalAlerts;